export default __webpack_public_path__ + "static/media/sponsor-bg-m-2-id.b46e6033.webp";